import type { ShiftBreaksList } from '@libs/data-access/queries'
import moment from 'moment'

import type { BreakRow } from '../components/BreakRowsContainer/BreakRowsContainer'

/**
 * @deprecated please don't
 */
const getBreaksLegacy = (
  defaultBreak?: number,
  shiftBreaks?: ShiftBreaksList,
  shiftId?: number
): { value: BreakRow }[] => {
  // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
  if (shiftBreaks?.size > 0) {
    // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
    return shiftBreaks
      .map(shiftBreak => ({
        value: {
          // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
          id: shiftBreak.get('id') || null,
          // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
          plannedDuration: shiftBreak.get('planned_duration'),
          // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
          ...(shiftBreak.get('planned_starts_at') && {
            timeRange: [
              // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
              moment(shiftBreak.get('planned_starts_at')).format('HH:mm'),
              // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
              moment(shiftBreak.get('planned_ends_at')).format('HH:mm')
            ]
          })
        }
      }))
      .toArray()
  }

  return defaultBreak && !shiftId
    ? [
        {
          value: {
            // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
            id: null as number,
            plannedDuration: defaultBreak,
            timeRange: [] as string[]
          }
        }
      ]
    : []
}

export default getBreaksLegacy
